import React from 'react';
import { MultiSelect, Option } from '../../../../../../components/ui/multi-select';
import { CollapsibleFilterBar } from '../../materials/tabs/Filters/CollapsibleFilterBar';

interface NDEFilterState {
  consumableCategory: string[];
  consumableType: string[];
  lotNumber: string[];
  serialNumber: string[];
  manufacturer: string[];
  location: string[];
}

interface NDEFiltersProps {
  searchQuery: string;
  onSearchChange: (value: string) => void;
  filters: NDEFilterState;
  onFilterChange: (key: keyof NDEFilterState) => (value: string[]) => void;
  uniqueConsumableCategories: string[];
  uniqueConsumableTypes: string[];
  uniqueLotNumbers: string[];
  uniqueSerialNumbers: string[];
  uniqueManufacturers: string[];
  uniqueLocations: string[];
  hasActiveFilters: boolean;
  filteredCount: number;
  onResetFilters: () => void;
  consumableTypeLabel?: string;
}

export const NDEFilters: React.FC<NDEFiltersProps> = ({
  searchQuery,
  onSearchChange,
  filters,
  onFilterChange,
  uniqueConsumableTypes,
  uniqueLotNumbers,
  uniqueSerialNumbers,
  uniqueManufacturers,
  uniqueLocations,
  filteredCount,
  onResetFilters,
  consumableTypeLabel = 'NDE',
}) => {
  const typeOptions: Option[] = uniqueConsumableTypes.map((type) => ({ value: type, label: type }));
  const lotNumberOptions: Option[] = uniqueLotNumbers.map((lotNum) => ({ value: lotNum, label: lotNum }));
  const serialNumberOptions: Option[] = uniqueSerialNumbers.map((serialNum) => ({ value: serialNum, label: serialNum }));
  const manufacturerOptions: Option[] = uniqueManufacturers.map((manufacturer) => ({ value: manufacturer, label: manufacturer }));
  const locationOptions: Option[] = uniqueLocations.map((location) => ({ value: location, label: location }));

  const activeFilterCount =
    filters.consumableType.length +
    filters.lotNumber.length +
    filters.serialNumber.length +
    filters.manufacturer.length +
    filters.location.length;

  return (
    <CollapsibleFilterBar
      searchQuery={searchQuery}
      onSearchChange={onSearchChange}
      searchPlaceholder="Search by category, type, lot number, serial number, manufacturer, location, or notes..."
      activeFilterCount={activeFilterCount}
      filteredCount={filteredCount}
      filteredCountLabel={`${consumableTypeLabel} consumables`}
      onResetFilters={onResetFilters}
    >
      <MultiSelect
        options={typeOptions}
        selected={filters.consumableType}
        onChange={onFilterChange('consumableType')}
        placeholder="Type"
      />
      <MultiSelect
        options={lotNumberOptions}
        selected={filters.lotNumber}
        onChange={onFilterChange('lotNumber')}
        placeholder="Lot Number"
      />
      <MultiSelect
        options={serialNumberOptions}
        selected={filters.serialNumber}
        onChange={onFilterChange('serialNumber')}
        placeholder="Serial Number"
      />
      <MultiSelect
        options={manufacturerOptions}
        selected={filters.manufacturer}
        onChange={onFilterChange('manufacturer')}
        placeholder="Manufacturer"
      />
      <MultiSelect
        options={locationOptions}
        selected={filters.location}
        onChange={onFilterChange('location')}
        placeholder="Location"
      />
    </CollapsibleFilterBar>
  );
};
